<template>
	<div>
		<bsh-datatable 
			:columns="columns"
            :buttons="buttons" 
			:link="$url+'/api/adm/clientes/datatable'"
            actionFild
            @selectRow="visualizar"
            @visualizar="visualizar"
			sorting>
		</bsh-datatable>
	</div>
</template>

<script>
export default {
	data(){
		return {
            columns: [
                {
                    label: 'Nome',
                    field: 'nome',
                    sort: 'asc'
                },
                {
                    label: 'C.P.F.',
                    field: 'cpf',
                    sort: 'asc'
                },
                {
                    label: 'Data de Nascimento',
                    field: 'data_nascimento',
                    sort: 'asc'
                },
            ],
            buttons: [
                {
                    action: 'visualizar',
                    classe: 'btn btn-primary',
                    iconClass: 'fas fa-eye'
                },
            ]
    	}
	},
    methods: {
        visualizar(dado){
            this.$emit('show', dado.id);
        }
    }
}
</script>